module.exports = __webpack_public_path__ + "img/product-preview-65.b611b92.png";